import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { whyPoints } from '../data/homepage';
export function WhyUs() {
  return <section id="why-us" aria-labelledby="why-heading" className="on-light bg-paper pb-24 pt-12 md:pb-32" data-id="element-253" data-mp="ssqob5groyi0">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 md:grid-cols-2 md:gap-16 md:px-10 lg:gap-24" data-id="element-254" data-mp="17lj1zrckhz7h">
        <Reveal data-id="element-255" data-mp="1gk4fv973gq1x">
          <figure data-id="element-256" data-mp="1gjmjmckfmbu0">
            <div className="aspect-[4/5] w-full overflow-hidden rounded-sm bg-navy-soft" data-id="element-257" data-mp="1gj30wtmyjjex">
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/92009e0e-46c6-4e0a-8356-a6a96fba8233.jpg" alt="In a school gym, a parent in a plain utility uniform lifts off a costume mascot head as a young child runs toward them, shocked and overjoyed." width={1200} height={1500} loading="lazy" className="h-full w-full object-cover" data-id="element-258" data-mp="1chrbop7zx079" />
            </div>
            <figcaption className="mt-4 text-lg text-charcoal/75" data-id="element-259" data-mp="3ebbgpxk8oxdx">We know what coming home means.</figcaption>
          </figure>
        </Reveal>

        <Reveal delay={0.05} data-id="element-260" data-mp="3ja4kuzdmzc1f">
          <h2 id="why-heading" className="font-serif text-4xl font-semibold leading-tight text-navy md:text-5xl" data-id="element-261" data-mp="3nbhu7jfxtxd3">
            We've worn the same boots.
          </h2>
          <div aria-hidden="true" className="mt-8 h-px w-16 bg-gold" data-id="element-262" data-mp="3s3hnwu5ezu18" />
          <p className="mt-8 text-lg leading-relaxed text-charcoal md:text-xl" data-id="element-263" data-mp="uu44imtoevs">
            We are not a faceless corporation and we are not a chatbot. We are a small team who served, most of
            us in military medicine, and we treat your claim like it belongs to one of our own.
          </p>
          <ul className="mt-10 space-y-5" data-id="element-264" data-mp="eud952kc7a3v">
            {whyPoints.map(point => <li key={point} className="flex items-start gap-4" data-id="element-265" data-mp="2cm7ogijjgiqr">
                <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-navy" data-id="element-266" data-mp="2gn1htrfr2pr1">
                  <CheckIcon aria-hidden="true" className="h-4 w-4 text-gold" strokeWidth={3} data-id="element-267" data-mp="3jxf8g24j3p52" />
                </span>
                <span className="text-lg leading-relaxed text-charcoal" data-id="element-268" data-mp="3ezvvr6nhbkf8">{point}</span>
              </li>)}
          </ul>
        </Reveal>
      </div>
    </section>;
}